// extracted by mini-css-extract-plugin
export default {"container":"style_container__Z9x7q","card":"style_card__xKjxn"};